// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import dthinkEntity from './entities/dthink.json';
import dthinkMenu from '../pages/dthink/menu.json';
import dthinkFullForm from '../pages/dthink/forms/full.json';
import dthinkContextForm from '../pages/dthink/forms/context.json';
import dthinkMiniForm from '../pages/dthink/forms/mini.json';
import dthinkLookupForm from '../pages/dthink/forms/lookup.json';
import dthinkTableView from '../pages/dthink/views/table.json';
import dthinkStagesView from '../pages/dthink/views/stages.json';
import dthinkCardsView from '../pages/dthink/views/cards.json';
import dthinkInlineView from '../pages/dthink/views/inline.json';
import dthinkBacklogView from '../pages/dthink/views/backlog.json';
import dthinkSplitView from '../pages/dthink/views/split.json';
import dthinkCalendarView from '../pages/dthink/views/calendar.json';
import dthinkDashboardView from '../pages/dthink/views/dashboard.json';

/** Тип запису «Дизайн-проєкт» зі сторінками пакета: меню, форми та подання з pages/dthink/. */
export const dthinkDefinition: IRecordTypeDefinition = {
  ...dthinkEntity,
  views: assembleViewSet({
      table: dthinkTableView,
      stages: dthinkStagesView,
      cards: dthinkCardsView,
      inline: dthinkInlineView,
      backlog: dthinkBacklogView,
      split: dthinkSplitView,
      calendar: dthinkCalendarView,
      dashboard: dthinkDashboardView,
  }),
  form: dthinkFullForm,
  forms: { full: dthinkFullForm, context: dthinkContextForm, mini: dthinkMiniForm, lookup: dthinkLookupForm },
  menu: dthinkMenu,
} as IRecordTypeDefinition;
